import { Box, Flex, HStack, VStack } from '@chakra-ui/react'
import React, { FC, ReactNode } from 'react'

export const ListPageDesktop: FC<{
  children?: never
  renderElement(displayName: string): ReactNode
}> = ({ renderElement }) => (
  <Box backgroundColor="neutral.10" w="100%">
    <VStack w="100%">
      <Flex alignItems="stretch" w="100%">
        <Flex flexDirection="column">
          {renderElement('ListPage.FilterPanel')}
        </Flex>
        <Flex flexDirection="column" p="40px 80px 40px 40px" w="100%">
          <Flex
            alignItems="baseline"
            justifyContent="space-between"
            mb="18px"
            w="100%"
          >
            <HStack alignItems="baseline">
              {renderElement('ListPage.Header')}
              {renderElement('ListPage.InformationPanel')}
            </HStack>
            {renderElement('ListPage.SortPanel')}
          </Flex>

          {renderElement('ListPage.ContentPanel')}
          {renderElement('ListPage.Pagination')}
        </Flex>
      </Flex>
    </VStack>
  </Box>
)
